import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/balance-sheet/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/balance-sheet/$id/dashboard', params });
  },
});
